module.exports = __webpack_public_path__ + "static/img/loginLogo.b3f9a56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loginLogo.png
// module id = hgJT
// module chunks = 1